import React from 'react';
import { Spinner } from '@insurancemenu/imenu-components-lib';
import clsx from 'clsx';
import { createStyles } from './styles';

interface FormSpinnerProps {
  display: boolean;
  size?: string;
  semiTransparentBg?: boolean;
  styles?: string;
  spinnerStyle?: string;
}

const FormsSpinner: React.FC<FormSpinnerProps> = ({
  display,
  size,
  semiTransparentBg = true,
  styles = '',
  spinnerStyle = '',
}) => {
  const classes = createStyles(semiTransparentBg);
  return display ? (
    <div className={clsx(classes.spinnerWrapper, styles)}>
      <Spinner size={size || '8rem'} className={spinnerStyle} />
    </div>
  ) : null;
};

export default FormsSpinner;
